import { useMemo } from 'react';
import { useLocalizationContext } from './localization-context';

export const useGetDayjsLocalizedCalendarLabels = () => {
  const { rawTranslate } = useLocalizationContext();

  return useMemo(
    () => ({
      sameDay: rawTranslate('dates.localizedLabels.sameDay'),
      lastDay: rawTranslate('dates.localizedLabels.lastDay'),
      lastWeek: rawTranslate('dates.localizedLabels.lastWeek'),
    }),
    [rawTranslate],
  );
};
